import { unstable_requirePropFactory as requirePropFactory } from '@material-ui/utils';
export default requirePropFactory;